// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4nooY","paragraph":"styles_paragraph__BOh9p"};